module.exports = __webpack_public_path__ + "609b46396832862336ca98fda76996fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-hus.png
// module id = 2083
// module chunks = 4